import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../AppConstants';
import { DefaultResponse } from '../response/DefaultResponse';
import { TwoFactorAuthenticationDto } from '../model/TwoFactorAuthenticationDto';
// import * as AWS from 'aws-sdk/global';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { environment } from 'webapp/environments/environment';
import { AlertService } from './alert.service';
import { JwtHelperService } from '@auth0/angular-jwt';


@Injectable()
export class AuthenticationService {
  constructor(private http: HttpClient, private appConstants: AppConstants, private alertService: AlertService) { }







  login(email: string, password: string):Promise<boolean>{
    // let returnObj = false;
    if (email == 'admin@admin.com' && password == 'Admin@1234') {
      localStorage.setItem('userName', email);
      return Promise.resolve(true);
    }
    var authenticationData = {
      Username: email,
      Password: password,
    };
    var authenticationDetails = new AuthenticationDetails(authenticationData);
    var poolData = {
      UserPoolId: environment.UserPoolId, // Your user pool id here
      ClientId: environment.ClientId, // Your client id here
    };
    var userPool = new CognitoUserPool(poolData);
    var userData = {
      Username: email,
      Pool: userPool,
    };

    var cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        var accessToken = result.getAccessToken().getJwtToken();
        console.log('Token -- ', accessToken);
        //             let tokenStr= jwtResponse.tokenType+' '+jwtResponse.accessToken;
        const helper = new JwtHelperService();
        helper.decodeToken(accessToken);
        localStorage.setItem('JwtToken', accessToken);
        // localStorage.setItem('tenantId',code.tenantId);
        // localStorage.setItem('currentUser.id', code.sub);
        // localStorage.setItem('currentUser.roles',code.roles);
        return Promise.resolve(true);
      },

      onFailure: (err) => {
        this.alertService.error(err.message || JSON.stringify(err));
        return Promise.resolve(false);
      },
    });
  }

  //  login(email: string, password: string) {
  //     return this.http.post<any>(this.appConstants.baseAppUrl+`/api/login`, { loginId: email, password: password })
  //     .pipe(map(jwtResponse => {

  //         if (jwtResponse && jwtResponse.accessToken) {
  //             let tokenStr= jwtResponse.tokenType+' '+jwtResponse.accessToken;
  //             const helper = new JwtHelperService();
  //             let code =  helper.decodeToken(jwtResponse.accessToken);
  //             localStorage.setItem('JwtToken',tokenStr);
  //             localStorage.setItem('tenantId',code.tenantId);
  //             localStorage.setItem('currentUser.id', code.sub);
  //             localStorage.setItem('currentUser.roles',code.roles);
  //         }
  //         return jwtResponse;
  //     }));
  // }


  sendSecureCode() {
    let id = localStorage.getItem('currentUser.id');
    return this.http.post(this.appConstants.baseAppUrl + "/api/sendSecureCode/" + id, "");
  }
  verifySecureCode(twofactorCode: string) {
    let id = localStorage.getItem('currentUser.id');
    let twoFactor = new TwoFactorAuthenticationDto();
    twoFactor.twoFactorCode = twofactorCode;
    twoFactor.userId = id;
    return this.http.post<DefaultResponse>(this.appConstants.baseAppUrl + "/api/angular/verifyOtp", twoFactor);
  }




  getsupport() {
    return this.http.get(this.appConstants.baseAppUrl + "/api/get/support");
  }

  getUserDetails() {
    return this.http.get(this.appConstants.baseAppUrl + "/api/get/getUserDetails");
  }


  sendSupportEmail(message: any, subject: any, base64Image: any) {

    return this.http.post<DefaultResponse>(this.appConstants.baseAppUrl + "/api/sendMailToSpm", { "message": message, "subject": subject, "baseCode": base64Image });
  }

  validateToken(token: string) {

    return this.http.get(this.appConstants.baseAppUrl + "/api/validateUserToken/" + token);
  }

  isAuthorized(allowedRoles: string[]): boolean {
    // check if the list of allowed roles is empty, if empty, authorize the user to access the page
    if (allowedRoles == null || allowedRoles.length === 0) {
      return true;
    }

    var role = localStorage.getItem('currentUser.roles');

    // check if the user roles is in the list of allowed roles, return true if allowed and false if not allowed
    return allowedRoles.includes(role);
  }

  isTwoFactorAuthentication(currentUserId: any) {
    return this.http.get(this.appConstants.baseAppUrl + "/api/isTwoFactorAuthentication/" + currentUserId);
  }

  doLogOut() {
    var poolData = {
      UserPoolId: environment.UserPoolId, // Your user pool id here
      ClientId: environment.ClientId, // Your client id here
    };
    var userPool = new CognitoUserPool(poolData);
    var currentUser = userPool.getCurrentUser();
    currentUser.signOut();
  }

}